import { Textarea as ChakraTextarea } from "@chakra-ui/react";
import React from "react";
import { INPUT_DEFAULT_PSEUDOBOX_BEHAVIOUR } from "styles/input-default-pseudobox-behaviour";

const sizes = {
  sm: {
    fontSize: "sm",
    padding: 3,
  },
  md: {
    fontSize: "sm",
    padding: 3,
  },
  lg: {
    fontSize: "sm",
    padding: 3,
  },
  base: {
    fontSize: "base",
    padding: 3,
  },
};

export type TextareaProps = React.ComponentPropsWithoutRef<
  typeof ChakraTextarea
> & {
  size?: "sm" | "md" | "lg" | "base";
};

export const Textarea = React.forwardRef<any, TextareaProps>((props, ref) => {
  const {
    id,
    name,
    size,
    onChange,
    defaultValue,
    onBlur,
    placeholder,
    value,
    isDisabled,
    ...rest
  } = props;

  return (
    <ChakraTextarea
      id={id}
      name={name}
      ref={ref}
      onChange={onChange}
      defaultValue={defaultValue}
      onBlur={onBlur}
      borderRadius="md"
      fontSize={sizes[size || "base"].fontSize}
      px={sizes[size || "base"].padding}
      placeholder={placeholder}
      value={value}
      border="1px solid"
      borderColor="gray.300"
      isDisabled={isDisabled}
      {...INPUT_DEFAULT_PSEUDOBOX_BEHAVIOUR}
      {...rest}
    />
  );
});
